<template>
  <div>
    <v-layout mt-4 child-flex>
      <div>
        <v-tabs>
          <v-tab> <v-icon left>description</v-icon>General </v-tab>
          <v-tab> <v-icon left>room</v-icon>Locations </v-tab>
          <!-- <v-tab> <v-icon left>people</v-icon>Contacts </v-tab> -->
          <v-tab-item>
            <v-card>
              <v-layout mt-4 wrap pt-4>
                <v-flex xs12 md4 pl-2 pr-2>
                  <v-text-field
                    v-model="distributor.name"
                    outlined
                    label="Name"
                    dense
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 md4 pl-2 pr-2>
                  <v-text-field
                    v-model="distributor.notes"
                    outlined
                    textarea
                    dense
                    label="Notes"
                  />
                </v-flex>
              </v-layout>
              <v-divider />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <div class="mt-4">
              <Table
                table-title="Distributor Locations"
                :headers="locationHeaders"
                :items="distributor.distributorLocations"
                icon="room"
                :client-search="true"
                hide-footer
                :show-banner="false"
                :actions="locationActions"
                :items-per-page="20"
                :primaryActionText="
                  canUpdateDistributor ? 'New Location' : false
                "
                primaryActionIcon="add"
                @primary-action-event="setAddLocation"
              />
            </div>
          </v-tab-item>
          <!-- <v-tab-item>
            <div class="mt-4">
              <Table
                table-title="Distributor Contacts"
                v-if="canUpdateDistributor"
                :headers="contactHeaders"
                :items="distributor.contacts"
                icon="person"
                :client-search="true"
                hide-footer
                :show-banner="false"
                :actions="contactActions"
                :items-per-page="20"
                :primaryActionText="
                  canUpdateDistributor ? 'New Contact' : false
                "
                primaryActionIcon="add"
                @primary-action-event="setAddContact"
              />
            </div>
          </v-tab-item> -->
        </v-tabs>
        <v-layout v-if="canUpdateDistributor">
          <v-flex mt-4 ml-4 mb-4>
            <v-btn @click="saveDistributor" color="primary">Save</v-btn>
          </v-flex>
        </v-layout>
        <contact-modal
          v-if="contactModal"
          :title="contactModalTitle"
          :contactModal.sync="contactModal"
          :contact="activeContact"
          @save="saveContact"
        />
        <distributor-location-modal
          v-if="distributorLocationModal"
          :title="distributorModalTitle"
          :distributorLocation="activeLocation"
          :distributorLocationModal.sync="distributorLocationModal"
          @save="saveLocation"
        />
      </div>
    </v-layout>
  </div>
</template>

<script>
import request from "@/modules/request";
import Table from "@/components/Table";
import ContactModal from "@/components/shared/modals/ContactModal";
import { hasPermission } from "@/modules/rbac/permission-manifest";
import DistributorLocationModal from "@/components/shared/modals/DistributorLocationModal";

export default {
  name: "Distributor",
  inject: ["snackBar", "reactiveInjected"],
  async mounted() {
    await this.getDistributor();
    this.setContactActions();
    this.setLocationActions();
  },
  components: {
    Table,
    ContactModal,
    DistributorLocationModal,
  },
  computed: {
    distributorModalTitle() {
      const { locationAction } = this;
      return locationAction === "editing" ? "Edit Location" : "Add Location";
    },
    contactModalTitle() {
      return this.contactAction === "editing"
        ? "Update Contact"
        : "Add Contact";
    },
  },
  data() {
    return {
      distributorLocationModal: false,
      distributor: null,
      locationAction: null,
      activeLocation: null,
      contactAction: null,
      contactModal: false,
      activeContact: null,
      locationActions: [],
      contactActions: [],
      locationHeaders: [
        {
          text: "Name",
          value: "address.name",
        },
        {
          text: "Address",
          value: "address.formatted_address",
        },
        {
          text: "Emails",
          value: "emails_list",
        },
        {
          text: "",
          value: "action",
        },
      ],
      contactHeaders: [
        {
          text: "First",
          value: "firstName",
        },
        {
          text: "Last",
          value: "lastName",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Phone",
          value: "phone",
        },
        {
          text: "Title",
          value: "title",
        },
        {
          text: "",
          value: "action",
        },
      ],
      canUpdateDistributor: hasPermission(
        "canUpdateDistributor",
        null,
        this.reactiveInjected.activeUser
      ),
    };
  },
  methods: {
    async saveLocation(location) {
      const { locationAction } = this;
      location.name = location.address.name;
      this.distributorLocationModal = false;
      if (locationAction === "editing") {
        await request
          .callInternal({
            method: "patch",
            route: `/api/admin/distributorlocation/${this.activeLocation._id}`,
            data: location,
          })
          .then(() => {
            this.snackBar("Saved!", "success");
          })
          .catch((error) => {
            this.snackBar("Sorry, something went wrong", "error");
            console.error(error);
          });
        this.getDistributor();
      } else if (locationAction === "adding") {
        await request
          .callInternal({
            method: "post",
            route: "/api/admin/distributorlocation",
            data: location,
          })
          .then(() => {
            this.snackBar("Added!", "success");
          })
          .catch((error) => {
            this.snackBar("Sorry, something went wrong", "error");
            console.error(error);
          });
        this.distributor.distributorLocations.push(location);
      }
    },
    setContactActions() {
      if (this.canUpdateDistributor) {
        this.contactActions.push({
          color: "primary",
          click: this.setEditingContact,
          text: "Edit",
        });
      }
    },
    setLocationActions() {
      if (this.canUpdateDistributor) {
        this.locationActions.push({
          color: "primary",
          click: this.setEditingLocation,
          text: "Edit",
        });
      }
    },
    setAddContact() {
      this.activeContact = {
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        title: null,
        notes: null,
      };
      this.contactModal = true;
      this.contactAction = "adding";
    },
    setAddLocation() {
      this.distributorLocationModal = true;
      const distributorId = this.$route.params.id;
      this.activeLocation = {
        distributor: distributorId,
        address: {
          formatted_address: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null,
        },
        emails: [],
      };
      this.locationAction = "adding";
    },
    setEditingLocation(location) {
      this.activeLocation = location;
      this.locationAction = "editing";
      this.distributorLocationModal = true;
    },
    setEditingContact(contact) {
      this.contactModal = true;
      this.activeContact = contact;
      this.contactAction = "editing";
    },
    async getDistributor() {
      const id = this.$route.params.id;
      const results = await request
        .callInternal({
          method: "get",
          route: `/api/admin/distributor/${id}`,
        })
        .catch((error) => {
          console.error(error);
          return;
        });
      this.distributor = results.data;
      this.formatEmailColumn();
    },
    formatEmailColumn() {
      const { distributorLocations } = this.distributor;
      this.distributor.distributorLocations.forEach(
        (location, locationIndex) => {
          this.distributor.distributorLocations[
            locationIndex
          ].emails_list = location.emails
            .map((email, emailIndex) => {
              return email.email;
            })
            .join(", ");
        }
      );
    },
    saveContact(contact) {
      const { contactAction } = this;

      if (contactAction === "editing") {
        const contactIndex = this.distributor.contacts.find(
          (cont) => cont._id === contact._id
        );
        this.distributor.contacts[contactIndex] = contact;
      } else {
        this.distributor.contacts.push(contact);
      }
      this.contactModal = false;
      this.saveDistributor();
    },
    async saveDistributor() {
      const id = this.$route.params.id;
      await request
        .callInternal({
          method: "patch",
          route: `/api/admin/distributor/${id}`,
          data: this.distributor,
        })
        .then(() => {
          this.snackBar("Distributor saved!", "success");
        })
        .catch((error) => {
          this.snackBar("Sorry, something went wrong", "error");
          console.error(error);
        });
    },
  },
};
</script>

<style scoped></style>
